import type { MaybeRef } from 'vue';
import { toValue } from 'vue';

import { getVolume, getVolumes } from './api';
import { volumeKeys } from './keys';

export const volumesQueryOptions = (params?: MaybeRef<{ page: number; query?: string }>) => ({
  queryKey: volumeKeys.volumes(params),
  queryFn: () => getVolumes(toValue(params)),
});

export const volumeQueryOptions = (uuid: MaybeRef<string>) => ({
  queryKey: volumeKeys.volume(uuid),
  queryFn: () => getVolume(toValue(uuid)).then((data) => data.volume),
});
